import { api } from "@/lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// GET with bounded retries for transient failures only (network error,
// timeout, 429, 5xx). Genuine 4xx answers (404 etc.) are returned at once.
export async function resilientGet(url, { retries = 2, baseDelayMs = 800 } = {}) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await api.get(url);
    } catch (err) {
      const status = err?.response?.status;
      const transient = !status || status === 429 || status >= 500;
      if (!transient || attempt >= retries) throw err;
      await sleep(baseDelayMs * 2 ** attempt);
    }
  }
}

// Prerendered first-response body (#__ssr_body__), only if it belongs to this path.
export function ssrBodyFor(pathname) {
  if (typeof document === "undefined") return null;
  const p = (s) => (s || "").replace(/\/+$/, "");
  if (p(window.__PRERENDER_PATH__) !== p(pathname)) return null;
  return document.getElementById("__ssr_body__");
}
